import { Directive, HostBinding } from '@angular/core';

@Directive({ selector: 'mri-master-detail-master-pane,[mriMasterDetailMasterPane]', standalone: true })
export class MasterDetailMasterPaneDirective {
  @HostBinding('class.mri-master-detail__master-pane') masterDetailHostClass = true;
}
